<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import SingleRowView from '../../components/GenericView/SingleRowView.svelte';
	import { actionInterpretator } from '../../helpers/scene_actions_to_ui';
	import type { DeviceActionUI } from '../../../../types/DeviceActionUI';
	import type { NotificationActionUI } from '../../../../types/NotificationActionUI';
	import type { SceneActionUI } from '../../../../types/SceneActionUI';
	import { extract_actions_variables } from './extract_actions_variables';
	import type { GroupActionUI } from '../../../../types/GroupActionUI';

	import { Label, Stack } from '@Shelly/shelly-design-system';

	export let element;

	const dispatch = createEventDispatcher();

	let msg_type = element.msg_type,
		purpose =
			element._gui_type ||
			element._gui_purpose ||
			element?.else?.blk[0]?._gui_type ||
			element?.else?.blk[0]?._gui_purpose ||
			undefined;

	let display_modal = false;

	if (element.else !== undefined) {
		//if there is else => it is a delay action, stupid, but in other way we miss it
		let copyDelay = { delay: element.wait, units: element.units };
		element = { ...element.else.blk[0], ...copyDelay };
	}
	let translated: NotificationActionUI | DeviceActionUI | SceneActionUI | GroupActionUI | undefined =
		actionInterpretator(purpose, element, msg_type);

	const { title, subtitle, labelList, withLabelList, avatar, description, actionList } =
		extract_actions_variables(translated);

	const handle_click = () => {
		display_modal = true;
	};
</script>

<SingleRowView
	{element}
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	withEdit={false}
	on:click={() => {
		dispatch('edit-else');
	}}
	on:open_detailed={() => handle_click()}
/>

{#if actionList && actionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each actionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
